import { render, staticRenderFns } from "./ModalSdtPeopleCreate.vue?vue&type=template&id=2fc4ea3a&scoped=true"
import script from "./ModalSdtPeopleCreate.vue?vue&type=script&lang=js"
export * from "./ModalSdtPeopleCreate.vue?vue&type=script&lang=js"
import style0 from "./ModalSdtPeopleCreate.vue?vue&type=style&index=0&id=2fc4ea3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4ea3a",
  null
  
)

export default component.exports